import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { OrdersWithPayment } from 'src/app/models/order';
import { OrderService } from 'src/app/order.service';
import { Router } from '@angular/router';
import { ImmediateSuggestion } from 'src/app/models/earned-reward';
import { AnalyticsService } from 'src/app/_services/analytics.service';

@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoCodeComponent implements OnInit {

  /** ENG-5609: unverified guest — rewards are hidden. */

  @Input() guestCheckout = false;


  @Input() orderWithPayment:OrdersWithPayment;
  @Input() disabled: boolean = false;
  @Output() refresh = new EventEmitter<boolean>();

  qualifyingOfferCount = 0;
  immediateSuggestions: ImmediateSuggestion[] = [];

  promoCodeApplied: boolean;
  conditionsMet: boolean;
  expand: boolean = false;
  isApplying = false;
  isRemoving = false;

  constructor(private orderService: OrderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
    this.promoCodeApplied = this.orderWithPayment.bot_order.promo_code.length > 0
    this.conditionsMet = +this.orderWithPayment.payment.promotional_discount > 0;
  }

  removePromoCode(){
    if (this.isRemoving) return;
    this.isRemoving = true;
    this.orderService.removePromoCode(this.orderWithPayment.bot_order.order_hash).subscribe({
      next: () => {
        this.isRemoving = false;
        this.promoCodeApplied = false;
        this.refresh.emit(true);
      },
      error: () => {
        this.isRemoving = false;
      }
    });
  }

  applyPromoCode(code){
    if (this.isApplying) return;
    this.isApplying = true;
    this.orderService.applyPromoCode(this.orderWithPayment.bot_order.order_hash, code).subscribe({
      next: () => {
        this.isApplying = false;
        this.analyticsService.trackEvent('apply_promo', { promo_code: code, success: true });
        this.refresh.emit(true);
      },
      error: (err) => {
        this.isApplying = false;
        const reason = err?.error?.reason;
        this.analyticsService.trackEvent('apply_promo', { promo_code: code, success: false, reason });
        // The backend says why a code was turned away (expired, already used, ...)
        alert(err?.error?.message || 'Invalid Promo Code Entered!');
      }
    });
  }

  onSuggestions(list: ImmediateSuggestion[]): void {
    this.immediateSuggestions = list || [];
    this.cdr.markForCheck();
  }

  goToPromo(){
    this.router.navigate(['order',
      this.orderWithPayment.bot_order.order_hash,
      'store',
      this.orderWithPayment.store.url_slug,
      'order-offers']);
  }

}
